import axios from 'axios' 
import config from '../../configure' 
import Login from '../../components/Login'

export const loadAcademicResult = () => {        
    return (dispatch) => {                      
        dispatch({ type: 'LOAD_ACADEMIC_RESULT_PENDING' })             
         const AuthStr = 'Bearer '.concat(localStorage.getItem('token')); 
         return axios({            
            method: 'get',
            url: `${config.API_URL}/AcademicResults`,
            headers: { Authorization: AuthStr } 
         }).then(results => {            
            dispatch({ type: 'LOAD_ACADEMIC_RESULT_SUCCESS', payload: results.data })        
        }).catch(err => {    
            // if (err.response && err.response.status === 401) {
                Login()
            // } else {
            //     dispatch({ type: 'LOAD_ACADEMIC_RESULT_REJECTED', payload: err })                   
            // }          
        })    
    } 
} 